import { take, put, call, all, takeLatest } from 'redux-saga/effects';
import moment from 'moment';

import {
  initProductsInfo,
  requestProductsStart,
  requestProductsSuccess,
  requestProductsFail,
} from '../actions/products';

import requestManagement from '../service/requestManagement';
const { method_POST, method_GET } = requestManagement;

import CONFIG from '@root/config/config.next';
const url = CONFIG.backendEndpoint;

export function* requestProducts(data) {

  /*console.log('[sages] requestProducts : ', data);*/

  const apiURL = `${url}/api/v1/products`;

  //====================================================================================================================

  try {
    const data = yield method_GET({ url: apiURL });

    /*console.log("[API] GET : ",);*/

    yield put(requestProductsSuccess(data));

  } catch (error) {
    yield put(requestProductsFail(error));
  }

  //====================================================================================================================

}

export function* watchProducts() {

  /*console.log('[sages] watchProducts : ✅');*/

  yield all([
    takeLatest(requestProductsStart, requestProducts),
  ])
}



